import React from "react";
import { isNullOrWhiteSpace } from "../shared/string";

export interface Props {
    title: string;
    municipalities: string[];
}

const MunicipalityList = ({ title, municipalities }: Props) => (
    <aside className="mb-12 md:mb-32 lg:mb-48">
        {!isNullOrWhiteSpace(title) &&
            <h2>{title}</h2>
        }
        <div className="px-12 py-4 lg:py-12 lg:px-20 rounded-lg bg-brand-primary-100 border border-tg-blue-light2">
            <ol className="lg:grid lg:grid-flow-col lg:grid-rows-12-dense lg:gap-x-8 lg:min-h-municipalities-list list-disc text-2xl text-municipalities leading-9">
                {municipalities.map(municipality => (
                    <li key={municipality}>{municipality}</li>
                ))}
            </ol>
        </div>
    </aside>
);

export default MunicipalityList;
